/* Warenkorb-Schublade (sections/loibl-schublade.liquid)
   - fängt "In den Warenkorb" ab, legt per /cart/add.js hinein und öffnet die Schublade
   - Klick auf den Warenkorb in der Kopfzeile öffnet sie statt /cart
   - Mengen ändern per /cart/change.js, danach Inhalt über die Section Rendering API neu laden
   Ohne JavaScript bleibt alles beim normalen Formular- und Linkverhalten. */
(function () {
  var wurzel = document.querySelector('[data-schublade]');
  if (!wurzel || !window.fetch) return;

  var flaeche = wurzel.querySelector('.schublade-flaeche');
  var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ausloeser = null;
  var bewegung = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function oeffnen() {
    ausloeser = document.activeElement;
    wurzel.hidden = false;
    document.documentElement.classList.add('schublade-offen');
    requestAnimationFrame(function () {
      wurzel.classList.add('ist-offen');
      flaeche.focus();
    });
  }

  function schliessen() {
    wurzel.classList.remove('ist-offen');
    document.documentElement.classList.remove('schublade-offen');
    var fertig = function () {
      if (!wurzel.classList.contains('ist-offen')) wurzel.hidden = true;
    };
    if (bewegung) flaeche.addEventListener('transitionend', fertig, { once: true });
    else fertig();
    if (ausloeser && ausloeser.focus) ausloeser.focus();
  }

  function neuLaden() {
    return fetch(basis + '?sections=loibl-schublade', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (daten) {
        var html = new DOMParser().parseFromString(daten['loibl-schublade'], 'text/html');
        var neu = html.querySelector('[data-schublade-inhalt]');
        var alt = wurzel.querySelector('[data-schublade-inhalt]');
        if (neu && alt) alt.replaceWith(neu);
        var anzahl = neu ? neu.getAttribute('data-anzahl') : null;
        if (anzahl !== null) {
          document.querySelectorAll('[data-warenkorb-anzahl]').forEach(function (el) { el.textContent = anzahl; });
        }
      });
  }

  // "In den Warenkorb": nur Produktformulare, die auf /cart/add zeigen.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var knopf = form.querySelector('[type="submit"]');
    if (knopf) knopf.disabled = true;
    fetch(basis + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (f) { throw new Error(f.description || f.message || 'Fehler'); });
        return neuLaden();
      })
      .then(oeffnen)
      .catch(function () { form.submit(); }) // im Zweifel der normale Weg über /cart
      .finally(function () { if (knopf) knopf.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-warenkorb-link]');
    if (link) {
      e.preventDefault();
      neuLaden().then(oeffnen, function () { window.location.href = link.href; });
      return;
    }
    if (e.target.closest('[data-schublade-zu]')) {
      schliessen();
      return;
    }
    var menge = e.target.closest('[data-schublade-menge]');
    if (menge) {
      menge.disabled = true;
      fetch(basis + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: menge.getAttribute('data-schublade-menge'), quantity: Number(menge.getAttribute('data-wert')) })
      }).then(neuLaden).catch(function () { menge.disabled = false; });
    }
  });

  // Jugendschutz-Häkchen als Warenkorb-Attribut sichern, damit es beim Neuladen der
  // Schublade (Menge ändern) stehen bleibt und auf der Warenkorbseite schon gesetzt ist.
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-jugendschutz]');
    if (!box) return;
    fetch(basis + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Alter bestätigt': box.checked ? 'ja' : '' } })
    });
  });

  document.addEventListener('keydown', function (e) {
    if (wurzel.hidden) return;
    if (e.key === 'Escape') { schliessen(); return; }
    if (e.key !== 'Tab') return;
    // Fokus in der Schublade halten.
    var ziele = flaeche.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!ziele.length) return;
    var erstes = ziele[0], letztes = ziele[ziele.length - 1];
    if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
    else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
  });
})();
